import { useSearchParams } from "react-router-dom";
import { Column } from "../../../common/components/CommonBaseComponents";
import ReportStatusSubTabContent from "./ReportStatusSubTabContent";
import ReportRecentRevenueSubTabContent from "./ReportRecentRevenueSubTabContent";
import Translate from "../../../common/translate/Translate";

const deviceSubTabs = [
    { value: "Status", label: Translate("store.tabs.report.status") },
    { value: "RecentRevenue", label: Translate("store.tabs.report.recentRevenue") },
];

function ReportTabContent({ storeId }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSubTab = searchParams.get("subTab") || "Status";

    const handleSetSubTab = (tabValue) => {
        setSearchParams({ tab: "Report", subTab: tabValue }, { replace: true });
    };

    return (
        <Column padding={"14px 0"} alignItem={"flex-start"} width={"100%"}>
            {activeSubTab === "Status" && (
                <ReportStatusSubTabContent
                    deviceSubTabs={deviceSubTabs}
                    handleSetSubTab={handleSetSubTab}
                    storeId={storeId}
                />
            )}
            {activeSubTab === "RecentRevenue" && (
                <ReportRecentRevenueSubTabContent
                    deviceSubTabs={deviceSubTabs}
                    handleSetSubTab={handleSetSubTab}
                    storeId={storeId}
                />
            )}
        </Column>
    );
}

export default ReportTabContent;
